import fs from 'node:fs'
import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { normalizeLoadedEntitySchema } from './normalize-loaded-entity-schema.js'
import { normalizeLoadedSchema } from './normalize-loaded-schema.js'
import { parseSchemaJson } from './parse-schema-json.js'
import { resolveSchemaFilePath } from './resolve-schema-file-path.js'
import { schemaKindFromType } from './schema-kind-from-type.js'

export function loadSchema(schemasDir: string, name: string): LoadedSchema {
  const filePath = resolveSchemaFilePath(schemasDir, name)
  const content = fs.readFileSync(filePath, 'utf-8')
  const parsed = parseSchemaJson(content, filePath)

  const obj = parsed as Record<string, unknown>

  switch (schemaKindFromType(name, obj.type)) {
    case 'form':
      return { type: 'form', schema: parsed as FormSchema, filePath }
    case 'single':
      return { type: 'single', schema: normalizeLoadedSchema(parsed), filePath }
    default:
      return { type: 'entity', schema: normalizeLoadedEntitySchema(parsed), filePath }
  }
}
